/**
 * Indicates that the form submission should proceed without interruption.
 */
export const FORM_SUBMISSION_PROCEED = 'PROCEED';

/**
 * Indicates that the form should be re-submitted and the next check should resolve with the PROCEED instruction.
 * We use it when some Forge custom fields were set by the user and then we re-submit the form to get them processed and resume the normal flow.
 */
export const FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED = 'RE-SUBMIT-AND-PROCEED';

/**
 * How long does the form wait before proceeding without Forge custom fields values to be submitted.
 * This is to prevent the form from hanging when there are "broken" custom fields (shouldn't happen but you never know).
 */
export const FORM_SUBMISSION_TIMEOUT = 10_000;
